import { Tag } from "primereact/tag";
import { Tooltip } from "primereact/tooltip";

import { SimulacaoTooltip } from "../simulacao-tooltip";
import styles from "./simulacao-marca.module.scss";
import type { SimulacaoMarcaTagViewModel } from "./types-simulacao-marca";

export function SimulacaoMarcaTagView({
  marca,
  selo,
  tooltipId,
  tooltipRef,
  alvo,
  registrarAlvo,
  aoTeclar,
}: SimulacaoMarcaTagViewModel) {
  return (
    <span
      ref={registrarAlvo}
      className={styles.alvo}
      tabIndex={0}
      aria-describedby={tooltipId}
      onKeyDown={aoTeclar}
    >
      <Tag className={styles.tag} value={selo} data-testid="simulacao-marca" />
      {alvo ? (
        <Tooltip
          ref={tooltipRef}
          id={tooltipId}
          target={alvo}
          className={styles.tooltip}
          pt={{ text: { className: styles.balao }, arrow: { className: styles.seta } }}
          position="top"
          event="both"
          showDelay={150}
        >
          <SimulacaoTooltip marca={marca} />
        </Tooltip>
      ) : null}
    </span>
  );
}
